export default __webpack_public_path__ + "static/media/spinner-primary.db7bac40.svg";